import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-under-construction-page',
  template: `
  <div>
      <app-under-construction></app-under-construction>
  </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderConstructionPageComponent {

  constructor() { }

}
